export const BRAZILIAN_UF_VALUES = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
] as const;

export type BrazilianUf = (typeof BRAZILIAN_UF_VALUES)[number];

export function isBrazilianUf(value: string): value is BrazilianUf {
  return (BRAZILIAN_UF_VALUES as readonly string[]).includes(value);
}

export function normalizeUf(value: string): string {
  return value.trim().toUpperCase();
}

export const BRAZILIAN_UF_LABELS: Record<BrazilianUf, string> = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

export function brazilianUfSelectOptions(): {
  value: BrazilianUf;
  label: string;
  searchValue: string;
}[] {
  return BRAZILIAN_UF_VALUES.map((value) => ({
    value,
    label: `${value} — ${BRAZILIAN_UF_LABELS[value]}`,
    searchValue: `${value} ${BRAZILIAN_UF_LABELS[value]}`,
  }));
}
